/* Utils */
import { generateEntityActionTypes } from '../utils/generators/actionTypeGenerators';

const ENTITY_NAME = 'SHOWS';

export const FETCH_SHOW_BY_ID = `${ENTITY_NAME}/FETCH/BY_ID`;
export const FETCH_CONTINUE_WATCHING_BY_SHOW_ID = `${ENTITY_NAME}/FETCH/CONTINUE_WATCHING_BY_SHOW_ID`;
export const SHOW_ENTITY_ACTION_TYPES = generateEntityActionTypes(ENTITY_NAME);
